import { Stack } from '@mui/material';
import { useEffect, useState } from 'react';
import VegaPageContent from '../../components/common/VegaPageContent';
import VegaPageHeader from '../../components/common/VegaPageHeader';
import VegaTabBar from '../../components/common/VegaTabBar';
import VegaTabBarItem from '../../components/common/VegaTabItem';
import VegaText from '../../components/common/VegaText';
import { toLowerCase } from '../../constants/commonFunction';
import { getTargetList, getTargetState } from '../../features/targetSlice';
import { useClientAuth } from '../../providers/ClientProvider';
import { useSnackbar } from '../../providers/SnackbarProvider';
import { useAppDispatch, useAppSelector } from '../../store';
import { TargetsStatus } from '../../types/targets';
import { getErrorMessageFromErrorObj } from '../../utils/api';
import ListOfTargetList from './modules/ListOfTargetList';
export enum TabType {
  PENDING = 'PENDING',
  COMPLETED = 'COMPLETED',
}

const TargetAdmin = () => {
  const { user } = useClientAuth();
  const dispatch = useAppDispatch();
  const { error } = useAppSelector(getTargetState);
  const { setSnackbar } = useSnackbar();
  const [selectedTab, setSelectedTab] = useState<number>(0);
  const [page, setPage] = useState<number>(0);
  const [size, setSize] = useState<number>(10);

  const fetchTargetList = () => {
    dispatch(
      getTargetList({
        approverId: user.id,
        listOfTargetStatus:
          selectedTab === 0
            ? [TargetsStatus.RAISED]
            : [`${TargetsStatus.APPROVED}`, `${TargetsStatus.REJECTED}`],
      })
    );
  };

  useEffect(() => {
    user && fetchTargetList();
  }, [selectedTab, page, user]);

  useEffect(() => {
    if (error) {
      setSnackbar(getErrorMessageFromErrorObj(error), 'error');
    }
  }, [error]);
  return (
    <>
      <VegaPageHeader
        isTabPresent
        renderLeftView={() => {
          return (
            <Stack spacing={'2rem'}>
              <VegaText
                text={'Targets'}
                fontWeight={600}
                fontSize={'1.0625rem'}
                color={'black'}
              />
              <VegaTabBar
                value={selectedTab}
                onChange={(e, selected) => {
                  setSelectedTab(selected);
                }}
              >
                <VegaTabBarItem label={toLowerCase(TabType.PENDING)} />
                <VegaTabBarItem label={toLowerCase(TabType.COMPLETED)} />
              </VegaTabBar>
            </Stack>
          );
        }}
      />
      {/* {selectedTab === 1 ? <CompletedTargetList /> : <PendingTargetList />} */}
      <VegaPageContent marginTop={'1.5rem'}>
        <ListOfTargetList
          selectedTab={selectedTab}
          page={page}
          size={size}
          setPage={setPage}
          setSize={setSize}
        />
      </VegaPageContent>
    </>
  );
};

export default TargetAdmin;
